import { Component } from '@angular/core';
import { Device } from '@ionic-native/device';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { Storage } from '@ionic/storage';
import { AlertController, LoadingController, NavController } from 'ionic-angular';
import { Api } from '../../providers/api';
import { UnprocessableEntityError } from '../../providers/api/errors/UnprocessableEntityError';
import { ErrorResponse } from '../../providers/api/responses/ErrorResponse';
import { UserService } from '../../providers/user-service';
import { HomePage } from '../home/home';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermsAndConditionsPage } from '../terms-and-conditions/terms-and-conditions';

@Component({
    selector: 'page-register',
    templateUrl: 'register.html'
})
export class RegisterPage {

    public firstName: string;
    public lastName: string;
    public emailAddress: string;
    public password: string;
    public confirmPassword: string;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public api: Api,
        public device: Device,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public storage: Storage,
        public userService: UserService,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Register');
    }

    public async register() {
        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.postRegister({
            firstname: this.firstName,
            lastname: this.lastName,
            email: this.emailAddress,
            password: this.password,
            device: {
                cordova: this.device.cordova,
                model: this.device.model,
                platform: this.device.platform,
                uuid: this.device.uuid,
                version: this.device.version,
                manufacturer: this.device.manufacturer,
                is_virtual: this.device.isVirtual,
                serial: this.device.serial,
            },
        }).finally(() => {
            loading.dismiss();
        }).subscribe(response => {
            this.storage.set('api_token', response.token);
            this.api.setToken(response.token);
            this.analytics.logEvent('sign_up', { method: 'in_app' });

            this.userService.setAndStore(response.user);

            this.navCtrl.setRoot(HomePage, null, {
                animate: true,
                direction: 'forward'
            });
        }, error => {
            if (error instanceof UnprocessableEntityError) {
                let errors = this.api.errorsToUl(error.errors);

                let alert = this.alertCtrl.create({
                    cssClass: 'alert-with-error-list',
                    title: 'Invalid Details',
                    subTitle: 'There were one or more issues with the information you entered',
                    message: errors.outerHTML,
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();

                return;
            }

            if (error instanceof ErrorResponse) {
                let alert = this.alertCtrl.create({
                    title: 'Error',
                    message: error.message,
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();

                return;
            }

            let alert = this.alertCtrl.create({
                title: 'Error',
                message: 'An unknown error has occured. Please try again.',
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        })

    }

    public showTermsOfUse() {
        this.navCtrl.push(TermsAndConditionsPage);
    }

    public showPrivacyPolicy() {
        this.navCtrl.push(PrivacyPolicyPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts